import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormBuilder, FormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {Select, Store} from "@ngxs/store";
import {AuthState, AuthStateModel} from "../../states/auth.state";
import {Observable, Subscription} from "rxjs";
import {Navigate} from "@ngxs/router-plugin";
import {LoginAction} from "../../actions/auth.actions";
import {ActivatedRoute} from "@angular/router";
import {environment} from "../../../environments/environment";
import { ViewIcon, ViewOffSlashIcon } from '@hugeicons-pro/core-stroke-rounded';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit,AfterViewInit,OnDestroy {

  appVersion:string=environment.appVersion;

  loginForm: UntypedFormGroup

  ViewIcon = ViewIcon;
  ViewOffSlashIcon = ViewOffSlashIcon;
  showPassword: boolean = false;

  private returnUrl: any;

  @Select(AuthState) auth$: Observable<AuthStateModel>;
  private auth$Sub: Subscription;
  loginError: boolean = false;

  constructor(
    private _builder:UntypedFormBuilder,
    private store: Store,
    private route: ActivatedRoute
  ) {
    this.loginForm = this._builder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['',[Validators.required]],
      remember: [''],
    })

    this.auth$Sub = this.auth$.subscribe( authData => {
      if(authData?.loginError) {
        this.loginError = true;
      }
      if(authData?.passwordExpired) {
        this.store.dispatch(new Navigate(['/account/reset-password']))
      }
    });
  }

  enviar(values) {

    const credentials = {
      user: values.email.trim(),
      pass: values.password.trim(),
      returnUrl: this.returnUrl,
      remember: values.remember
    }
    this.loginError = false;
    this.store.dispatch(new LoginAction(credentials))

  }

  ngOnInit(): void {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || 'home';
  }

  ngAfterViewInit() {
    if(localStorage.getItem("remember")) {
      let pass = localStorage.getItem('password');

      this.loginForm.patchValue({
        password:pass,
        remember:true
      })
    }
  }

  ngOnDestroy() {
    if(this.auth$Sub) {
      this.auth$Sub.unsubscribe();
    }
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
}
